import React, { FC } from 'react';

import { StockModelCardCaptionProps } from '.';
import useTranslations from '@hooks/useTranslations';
import DynamicExteriorImagePreview from '@components/DynamicExteriorImagePreview';

export const StockModelCardCaptionTemplate: FC<StockModelCardCaptionProps> = ({
    className,
    isColorAndInteriorDisplayed,
    color,
    interior,
    imageUrl,
    imageAlt,
}) => {
    const { t } = useTranslations();

    return (
        <div className={`${className} stockModelCard-imageContainer`}>
            <DynamicExteriorImagePreview imageUrl={imageUrl} minHeight={175} />
            {isColorAndInteriorDisplayed && (
                <div className="stockModelCard-imageContainer--info">
                    <span className="stockModelCard-imageContainer--info__list">
                        {color && (
                            <>
                                <dt className="highlighted-text">{t('stockModelCard.color')}:</dt>
                                <dd>{color}</dd>
                            </>
                        )}

                        {interior && (
                            <>
                                <dt className="highlighted-text">{t('stockModelCard.interior')}:</dt>
                                <dd>{interior}</dd>
                            </>
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default StockModelCardCaptionTemplate;
